export default __webpack_public_path__ + "static/media/user-icon-new.c96f4b1c.png";